import { connect } from 'react-redux';
import { compose } from 'redux';
import store from '../store';
import createHistory from 'history/createBrowserHistory';

import { withRouter } from 'react-router-dom';
import { clearErrors, clearMessages } from './messages';
import { doNavigateToProduct } from './products';

export const NAVIGATE = "NAVIGATE";

const navigate = url => {
    return {
        type: NAVIGATE,
        url
    };
};

export const history = createHistory();

// dispatch "navigate" action when url changes
history.listen((location) => {
  store.dispatch( navigate(location) );
});

/**
 * Navigation thunk
 * clears errors and messages from store and navigates to URL
 * @param {*} history 
 * @param {*} url 
 */
export const navigateTo = (history, url) => dispatch => {
    dispatch( clearMessages() );
    dispatch( clearErrors() );
    history.push(url);
}

export const withNavigation = compose(
  withRouter,
  connect(
    undefined,
    (dispatch, {history}) => ({
      navigateToSubscription: subscriptionId => 
        dispatch( navigateTo(history, `/subscriptions/${subscriptionId}`) ),
      navigateToSubscriptionEdit: subscriptionId => 
        dispatch( navigateTo(history, `/subscriptions/${subscriptionId}/update`) ),
      navigateToProduct: product => 
        dispatch( navigateTo(history, `/products/${product.id}`) ),
      navigateToHomepage: () => 
        dispatch( navigateTo(history, '/') ),
      navigateBackToProduct: product =>
        doNavigateToProduct(product),
      navigateToSupport: () => 
        document.location.href = 'https://support.aodocs.com/hc/en-us/requests/new'
    })
  )
)


// WEBPACK FOOTER //
// ./src/actions/navigation.js